<template>
    <div class="blog-post-area ptb-100">
        <div class="container-fluid">
            <div class="card-box-style">
                <div class="row justify-content-center">
                    <div class="col-xl-4 col-md-6">
                        <div class="single-blog">
                            <div class="blog-img">
                                <router-link to="/blog-details">
                                    <img src="../../assets/images/blog/blog-1.jpg" alt="blog-1">
                                </router-link>
                                <span class="date">12 Dec</span>
                            </div>

                            <div class="blog-content">
                                <h3>
                                    <router-link to="/blog-details">The Swag (And Humans) Of AWS Re: Invent 2021 Reviewed</router-link>
                                </h3>

                                <ul class="d-flex justify-content-between">
                                    <li class="admin">
                                        <router-link to="/blog-details"><img src="../../assets/images/blog/admin-1.jpg" alt="admin-1"></router-link>
                                        <span>By</span>
                                        <router-link to="/blog-details">Binter Carol</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/blog-details" class="read-more">
                                            Read Blog
                                            <i class="ri-arrow-right-line"></i>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-md-6">
                        <div class="single-blog">
                            <div class="blog-img">
                                <router-link to="/blog-details">
                                    <router-link to="/blog-details"><img src="../../assets/images/blog/blog-2.jpg" alt="blog-2"></router-link>
                                </router-link>
                                <span class="date">12 Dec</span>
                            </div>

                            <div class="blog-content">
                                <h3>
                                    <router-link to="/blog-details">University Admissions Could Face Emergency Controls</router-link>
                                </h3>

                                <ul class="d-flex justify-content-between">
                                    <li class="admin">
                                        <router-link to="/blog-details"><img src="../../assets/images/blog/admin-2.jpg" alt="admin-2"></router-link>
                                        <span>By</span>
                                        <router-link to="/blog-details">Staven Dew</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/blog-details" class="read-more">
                                            Read Blog
                                            <i class="ri-arrow-right-line"></i>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-md-6">
                        <div class="single-blog">
                            <div class="blog-img">
                                <router-link to="/blog-details">
                                    <img src="../../assets/images/blog/blog-3.jpg" alt="blog-3">
                                </router-link>
                                <span class="date">14 Dec</span>
                            </div>

                            <div class="blog-content">
                                <h3>
                                    <router-link to="/blog-details">Online Learning Can Prepare Students For Fast-Changing</router-link>
                                </h3>

                                <ul class="d-flex justify-content-between">
                                    <li class="admin">
                                        <router-link to="/blog-details"><img src="../../assets/images/blog/admin-3.jpg" alt="admin-3"></router-link>
                                        <span>By</span>
                                        <router-link to="/blog-details">Alex Carol</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/blog-details" class="read-more">
                                            Read Blog
                                            <i class="ri-arrow-right-line"></i>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-md-6">
                        <div class="single-blog">
                            <div class="blog-img">
                                <router-link to="/blog-details">
                                    <img src="../../assets/images/blog/blog-4.jpg" alt="blog-4">
                                </router-link>
                                <span class="date">12 Dec</span>
                            </div>

                            <div class="blog-content">
                                <h3>
                                    <router-link to="/blog-details">The Swag (And Humans) Of Aws Re:invent 2015 Reviewed</router-link>
                                </h3>

                                <ul class="d-flex justify-content-between">
                                    <li class="admin">
                                        <router-link to="/blog-details"><img src="../../assets/images/blog/admin-4.jpg" alt="admin-4"></router-link>
                                        <span>By</span>
                                        <router-link to="/blog-details">Binter Carol</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/blog-details" class="read-more">
                                            Read Blog
                                            <i class="ri-arrow-right-line"></i>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-md-6">
                        <div class="single-blog">
                            <div class="blog-img">
                                <router-link to="/blog-details">
                                    <img src="../../assets/images/blog/blog-5.jpg" alt="blog-5">
                                </router-link>
                                <span class="date">12 Dec</span>
                            </div>

                            <div class="blog-content">
                                <h3>
                                    <router-link to="/blog-details">The Swag (And Humans) Of Aws Re:invent 2016 Reviewed</router-link>
                                </h3>

                                <ul class="d-flex justify-content-between">
                                    <li class="admin">
                                        <router-link to="/blog-details"><img src="../../assets/images/blog/admin-5.jpg" alt="admin-5"></router-link>
                                        <span>By</span>
                                        <router-link to="/blog-details">Staven Dew</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/blog-details" class="read-more">
                                            Read Blog
                                            <i class="ri-arrow-right-line"></i>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-md-6">
                        <div class="single-blog">
                            <div class="blog-img">
                                <router-link to="/blog-details">
                                    <img src="../../assets/images/blog/blog-6.jpg" alt="blog-6">
                                </router-link>
                                <span class="date">14 Dec</span>
                            </div>

                            <div class="blog-content">
                                <h3>
                                    <router-link to="/blog-details">The Swag (And Humans) Of Aws Re:invent 2018 Reviewed</router-link>
                                </h3>

                                <ul class="d-flex justify-content-between">
                                    <li class="admin">
                                        <router-link to="/blog-details"><img src="../../assets/images/blog/admin-1.jpg" alt="admin-1"></router-link>
                                        <span>By</span>
                                        <router-link to="/blog-details">Alex Carol</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/blog-details" class="read-more">
                                            Read Blog
                                            <i class="ri-arrow-right-line"></i>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-md-6">
                        <div class="single-blog">
                            <div class="blog-img">
                                <router-link to="/blog-details">
                                    <img src="../../assets/images/blog/blog-7.jpg" alt="blog-7">
                                </router-link>
                                <span class="date">12 Dec</span>
                            </div>

                            <div class="blog-content">
                                <h3>
                                    <router-link to="/blog-details">The Swag (And Humans) Of Aws Re:invent 2019 Reviewed </router-link>
                                </h3>

                                <ul class="d-flex justify-content-between">
                                    <li class="admin">
                                        <router-link to="/blog-details"><img src="../../assets/images/blog/admin-2.jpg" alt="admin-2"></router-link>
                                        <span>By</span>
                                        <router-link to="/blog-details">Binter Carol</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/blog-details" class="read-more">
                                            Read Blog
                                            <i class="ri-arrow-right-line"></i>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-md-6">
                        <div class="single-blog">
                            <div class="blog-img">
                                <router-link to="/blog-details">
                                    <img src="../../assets/images/blog/blog-8.jpg" alt="blog-9">
                                </router-link>
                                <span class="date">14 Dec</span>
                            </div>

                            <div class="blog-content">
                                <h3>
                                    <router-link to="/blog-details">The Swag (And Humans) Of Aws Re:invent 2020 Reviewed </router-link>
                                </h3>

                                <ul class="d-flex justify-content-between">
                                    <li class="admin">
                                        <router-link to="/blog-details"><img src="../../assets/images/blog/admin-3.jpg" alt="admin-3"></router-link>
                                        <span>By</span>
                                        <router-link to="/blog-details">Staven Dew</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/blog-details" class="read-more">
                                            Read Blog
                                            <i class="ri-arrow-right-line"></i>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-md-6">
                        <div class="single-blog">
                            <div class="blog-img">
                                <router-link to="/blog-details">
                                    <img src="../../assets/images/blog/blog-9.jpg" alt="blog-9">
                                </router-link>
                                <span class="date">25 Dec</span>
                            </div>

                            <div class="blog-content">
                                <h3>
                                    <router-link to="/blog-details">The Swag (And Humans) Of Aws Re:invent 2022 Reviewed </router-link>
                                </h3>

                                <ul class="d-flex justify-content-between">
                                    <li class="admin">
                                        <router-link to="/blog-details"><img src="../../assets/images/blog/admin-4.jpg" alt="admin-4"></router-link>
                                        <span>By</span>
                                        <router-link to="/blog-details">Alex Carol</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/blog-details" class="read-more">
                                            Read Blog
                                            <i class="ri-arrow-right-line"></i>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12">
                        <div class="pagination-area text-center">
                            <a href="/blog" class="next page-numbers">
                                <i class="ri-arrow-left-line"></i>
                            </a>
                            <span class="page-numbers current" aria-current="page">1</span>
                            <a href="/blog" class="page-numbers">2</a>
                            <a href="/blog" class="page-numbers">3</a>
                            
                            <a href="/blog" class="next page-numbers">
                                <i class="ri-arrow-right-line"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BlogContent'
}
</script>

<style lang="scss">
.single-blog {
	margin-bottom: 30px;
	transition: var(--transition);
	background-color: var(--white-color);
	box-shadow: var(--box-shadow);
	padding: 30px;
	border-radius: 20px;
	.blog-img {
		margin-bottom: 20px;
		position: relative;
		img {
			border-radius: 5px;
		}
		.date {
			position: absolute;
			top: 20px;
			left: 20px;
			background-color: var(--main-color);
			color: var(--heading-color);
			width: 65px;
			height: 65px;
			line-height: 20px;
			text-align: center;
			background-color: var(--main-color);
			font-weight: 700;
			border-radius: 10px 10px 0px 10px;
			padding: 13px 11px;
		}
	}
	.blog-content {
		h3 {
			font-size: 20px;
			border-bottom: 1px solid #f7f7f7;
			padding-bottom: 20px;
			margin-bottom: 20px;
			line-height: 32px;
			a {
				color: var(--heading-color);
			}
		}
		ul {
			padding-left: 0;
			margin-bottom: 0;
			list-style-type: none;
			li {
				display: inline-block;
				img {
					position: relative;
					top: -2px;
				}
				&.admin {
					a {
						color: #0D0C0C;
						font-size: 14px;
						font-weight: 500;
					}
				}
				.read-more {
					font-weight: 500;
					font-size: 14px;
				}
			}
		}
	}
	&:hover {
		transform: translateY(-5px);
		.blog-content {
			h3 {
				a {
					color: var(--main-color);
				}
			}
		}
	}
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .single-blog {
        padding: 20px;
        .blog-content {
            h3 {
                font-size: 16px;
                line-height: 25px;
            }
        }
    }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
    .single-blog {
        padding: 20px;
        .blog-content {
            h3 {
                font-size: 16px;
                line-height: 25px;
            }
        }
    }
}
</style>